<template>
  <div>
    <div>
      <h2 class="do-h2">
        REGISTRO
      </h2>
      <p class="do-p">
        Registrarte te permitirá guardar tu selección de carreras e instituciones.
      </p>
      <h6>Términos y Condiciones</h6>
      <div class="terms-and-conditions">
        <p>
          Estás viendo la versión Beta/Piloto del Explorador de Educación Superior.
          Estamos continuamente trabajando en él y por lo tanto, algunos datos son preliminares
          y pueden cambiar.
        </p>
        <p>
          Recuerda que además de las informaciones de esta página web hay muchos otros elementos
          que debes considerar a la hora de elegir una carrera.
        </p>
        <p>
          Al acceder al piloto del explorador aceptas que tu información sea utilizada estrictamente
          con fines académicos y para mejorar el funcionamiento de la plataforma.
        </p>
      </div>
    </div>
    <form
      class="needs-validation"
      novalidate
      @submit.prevent="onRegisterSubmit"
    >
      <div
        class="form-check"
        style="margin-bottom: 1.5em;"
      >
        <input
          id="tc-accept"
          v-model="tocAccepted"
          type="checkbox"
          name="tc-accept"
          class="form-check-input"
          required
        >
        <label
          for="tc-accept"
          class="form-check-label"
        >Acepto los Términos y Condiciones</label>
        <div class="invalid-feedback">
          Recuerda aceptar los términos y condiciones para continuar.
        </div>
      </div>
      <div
        v-show="tocAccepted"
        class="box"
      >
        <div class="form-group">
          <label for="register-email">Correo electrónico:</label>
          <input
            id="register-email"
            ref="email"
            v-model="studentEmail"
            type="email"
            name="register-email"
            class="form-control"
            required
          >
          <div class="invalid-feedback">
            Asegúrate de escribir bien tu correo.
          </div>
          <div
            v-if="emailValidationMessage"
            class="mail-error"
          >
            {{ emailValidationMessage }}
          </div>
        </div>
        <div class="form-group">
          <label for="register-password">Contraseña:</label>
          <input
            id="register-password"
            ref="password"
            v-model="studentPassword1"
            type="password"
            name="register-password"
            class="form-control"
            required
            @input="checkPasswordValidity"
          >
          <div class="invalid-feedback">
            {{ validationMessage }}
          </div>
        </div>
        <div class="form-group">
          <label for="register-repeatpassword">Confirmar contraseña:</label>
          <input
            id="register-repeatpassword"
            v-model="studentPassword2"
            type="password"
            name="register-repeatpassword"
            class="form-control"
            required
            @input="checkPasswordsMatch"
          >
          <div class="invalid-feedback">
            Asegúrate que ambas contraseñas coincidan.
          </div>
        </div>
        <div class="form-group">
          <label for="register-phone">Teléfono (optativo):</label>
          <input
            id="register-phone"
            v-model="studentPhone"
            type="text"
            name="register-phone"
            class="form-control"
          >
        </div>
        <div class="mt-4">
          <button
            class="btn btn-primary btn-block"
            type="submit"
            :disabled="submitButtonDisabled"
          >
            Comenzar
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import store from '../../_store';
import { authenticationService, trackingService } from '../../_services';

export default {
    name: 'StudentRegister',
    data() {
        return {
            tocAccepted: false,
            studentEmail: '',
            studentPassword1: '',
            studentPassword2: '',
            studentPhone: null,

            validationMessage: '',
            emailValidationMessage: '',
            submitButtonDisabled: false,
        };
    },
    computed: {
        passwordValidityMessage() {
            if (this.studentPassword1.length < 8) return 'La contraseña es muy corta. Asegúrate que tenga al menos 8 caracteres.';
            if (/^\d*$/.test(this.studentPassword1)) return 'La contraseña no debe contener solamente números.';
            return '';
        },
    },
    watch: {
        studentEmail() {
            this.emailValidationMessage = '';
        },
    },
    beforeDestroy() {
        trackingService.new_register_tracks(
            window.localStorage.getItem('visitor_uuid'),
            true,
        );
    },
    methods: {
        submitRegistration() {
            return authenticationService.register(
                {
                    email: this.studentEmail,
                    password1: this.studentPassword1,
                    password2: this.studentPassword2,
                    phone: this.studentPhone ? Number(this.studentPhone.replace(/\D/g, '')) : null,
                },
            ).then((response) => {
                store.commit('authentication/loginSuccess', response);
                store.dispatch('loginDialog/setNextDialog');
            }).catch((err) => {
                if (err.response.status === 400 && err.response.data.password1) {
                    [this.validationMessage] = err.response.data.password1;
                    this.$refs.password.setCustomValidity(this.validationMessage);
                }
                if (err.response.status === 400 && err.response.data.email) {
                    [this.emailValidationMessage] = err.response.data.email;
                }
                store.commit('authentication/loginFailure', err);
            });
        },
        checkValidity(e) {
            return new Promise((resolve, reject) => {
                if (e.target.checkValidity()) resolve(); else {
                    reject(new Error('One or more form fields do not contain valid data'));
                }
            });
        },
        setButtonDisabled(disabledStatus) {
            return new Promise((resolve) => {
                this.submitButtonDisabled = (typeof disabledStatus !== 'undefined')
                    ? !!disabledStatus : !this.submitButtonDisabled;
                resolve();
            });
        },
        onRegisterSubmit(e) {
            this.emailValidationMessage = '';
            this.checkValidity(e)
                .then(() => this.setButtonDisabled(true))
                .then(() => this.submitRegistration())
                .catch((err) => {
                    e.stopPropagation();
                    throw new Error(`Problem with handling something: ${err}`);
                })
                .finally(() => {
                    e.target.classList.add('was-validated');
                    this.setButtonDisabled(false);
                });
        },
        checkPasswordsMatch(e) {
            e.target.setCustomValidity(this.studentPassword1 === this.studentPassword2 ? '' : 'Las contraseñas no coinciden.');
        },
        checkPasswordValidity(e) {
            this.validationMessage = this.passwordValidityMessage;
            e.target.setCustomValidity(this.passwordValidityMessage);
        },
    },
};
</script>
<style>
.terms-and-conditions {
  height: 12rem;
  overflow-y: scroll;
  margin-bottom: 1.5rem;
  border: solid 1px #e2e2e2;
  padding: 1rem;
  border-radius: 5px;
  background: white;
}
.mail-error {
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #dc3545;
}
</style>
